module.exports = __webpack_public_path__ + "img/compare.cdf2eee7.svg";